
import { Component, inject, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { IonButton } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { PosthogService } from 'src/app/services/analytics/posthog.service';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  imports: [
    TranslateModule,
    IonButton
]
})
export class CookieBannerComponent {
  posthogService = inject(PosthogService)

  showBanner = !localStorage.getItem('trackingConsent');

  constructor() {
    if (Capacitor.getPlatform() === 'web' && !localStorage.getItem('trackingConsent')) {
      this.showBanner = true;
    }
  }

  acceptCookies() {
    localStorage.setItem('trackingConsent', 'true');
    this.posthogService.enableTracking(); // Enable tracking after consent
    this.showBanner = false;
  }

  declineCookies() {
    localStorage.setItem('trackingConsent', 'false');
    this.showBanner = false;
  }
}
